import React from "react";
import Loader from "../../../Common/Loader/Loader";

const IframeLoader = (isIFrameLoaded) => {
  return (
    isIFrameLoaded && (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingTop: "10rem",
        }}
      >
        <Loader height={40} width={40} />
      </div>
    )
  );
};

export default IframeLoader;
